
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "social",
  "title": "Social Feed",
  "sidebar_label": "Social Feed"
};
const slug = 'social';
const tableOfContents = [];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#d658a4b3-5717-408c-bd8e-9ddb7463adc5"
      }}>{`API REFERENCE`}</a></p>
    <p>{`Our platform includes a range of social features that help to generate engagement between users and facilitate communication and interaction. These features include:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Liking listings:`}</strong>{` Users can like listings to show their appreciation or interest in a particular item.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Following accounts:`}</strong>{` Users can follow other accounts to stay updated on their activity and see their listings in their feed.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Chatting with accounts:`}</strong>{` Users can chat with other accounts to ask questions, make offers, or simply communicate with each other.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`User ratings and reviews:`}</strong>{` Users can rate and review each other based on their experiences with a particular account or transaction.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Wish lists:`}</strong>{` Users can add items to their wish list (also known as bookmarks, saves, or favorites) to refer to them in the future for further actions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Groups:`}</strong>{` (Alpha release) Users can join or create groups to discuss specific topics or interests with like-minded individuals.`}</p>
      </li>
    </ul>
    <p>{`On the roadmap, we have plans to add additional social features, including:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Comments on listings:`}</strong>{` Users will be able to leave comments on individual listings to share their thoughts or ask questions.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Public wish lists:`}</strong>{` Users will be able to make their wish lists public, allowing others to see the items they are interested in.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Stories:`}</strong>{` Similar to Instagram, users will be able to create and share stories featuring their listings or other content.`}</p>
      </li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
